export interface WebsiteConfig {
  name: string;
  theme: {
    primaryColor: string;
    secondaryColor: string;
    fontFamily: {
      primary: string;
      secondary?: string;
    };
  };
  assets: {
    logo: string;
    favicon: string;
    favicon32x32: string;
    favicon16x16: string;
    appleTouchIcon: string;
    siteWebmanifest: string;
    heroBackground: string;
    browserconfig: string;
    heroVideoWebm: string;
    aboutBg: string;
    profilePdf: string;
    esgEnvironmental: string;
    esgSocial: string;
    esgGovernance: string;
    service1: string;
    service2: string;
    service3: string;
    service4: string;
    service5: string;
    service6: string;
    news1: string;
    news2: string;
    news3: string;
    news4: string;
    news5: string;
    team1: string;
    team2: string;
    team3: string;
    team4: string;
    team5: string;
    team6: string;
    careersBg: string;
  };
  content: {
    localesPath: string;
  };
  seo: {
    titleKey: string;
    descriptionKey: string;
    keywordsKey: string;
    ogImage: string;
    ogImageWidth: string;
    ogImageHeight: string;
    twitterSite: string;
    canonicalDomain: string;
  };
}

export const websites: Record<string, WebsiteConfig> = {
  bluesky: {
    name: 'Bluesky',
    theme: {
      primaryColor: '#122449',
      secondaryColor: '#1E40AF',
      fontFamily: {
        primary: 'Almarai',
        secondary: 'Almarai',
      },
    },
    assets: {
      logo: '/websites/bluesky/logo.png',
      favicon: '/websites/bluesky/logo.png',
      heroBackground: '/websites/bluesky/hero.jpg',
      favicon32x32: '/websites/bluesky/favicon-32x32.png',
      favicon16x16: '/websites/bluesky/favicon-16x16.png',
      appleTouchIcon: '/websites/bluesky/apple-touch-icon.png',
      siteWebmanifest: '/websites/bluesky/site.webmanifest',
      browserconfig: '/websites/bluesky/browserconfig.xml',
      heroVideoWebm: '/websites/bluesky/hero.webm',
      aboutBg: '/websites/bluesky/about_bg.webp',
      profilePdf: '/websites/bluesky/profile-q3-2026.pdf',

      // ESG
      esgEnvironmental: 'https://images.unsplash.com/photo-1501004318641-b39e6451bec6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // nature / landscape
      esgSocial: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // diverse team smiling
      esgGovernance: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // meeting / governance feel

      // Services (clean, professional imagery)
      service1: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // team brainstorming
      service2: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // laptop + hands (work)
      service3: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // creative session
      service4: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // modern office
      service5: 'https://images.unsplash.com/photo-1518600506278-4e8ef466b810?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // hands together (teamwork)
      service6: 'https://images.unsplash.com/photo-1485217988980-11786ced9454?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // closeup tech / code

      // News / blog thumbnails
      news1: 'https://images.unsplash.com/photo-1509395176047-4a66953fd231?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // newsroom / desk
      news2: 'https://images.unsplash.com/photo-1634078111133-a1e12d6131b6?fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=60&w=3000', // person writing on notebook—a refined editorial thumbnail
      // modern writing desk in a bright, stylish office
      news3: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // people reading / tablet
      news4: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // modern workspace
      news5: '/websites/bluesky/Article5-bg.webp', // waste management / recycling
      team1: "/websites/bluesky/technology.jpg",
      team2: "/websites/bluesky/operations.jpg",
      team3: "/websites/bluesky/people.jpg",
      team4: "/websites/bluesky/finance.jpg",
      team5: "/websites/bluesky/engineering.jpg",
      team6: "/websites/bluesky/commercial.jpg",
      careersBg: '/websites/bluesky/careers_hero.webp',
    },

    content: {
      localesPath: '/websites/bluesky/locales',
    },
    seo: {
      titleKey: 'seo.title',
      descriptionKey: 'seo.description',
      keywordsKey: 'seo.keywords',
      ogImage: '/websites/bluesky/og-image.jpg',
      ogImageWidth: '1200',
      ogImageHeight: '630',
      twitterSite: '@blueskyenergy',
      canonicalDomain: 'blueskyenergy.com',
    },
  },
  emcor: {
    name: 'EMCOR',
    theme: {
      primaryColor: '#B12C00',
      secondaryColor: '#991B1B',
      fontFamily: {
        primary: 'Saira',
        secondary: 'Saira',
      },
    },
    assets: {
      logo: '/websites/emcor/logoNew.png',
      favicon: '/websites/emcor/logoNew.png',
      heroBackground: '/websites/emcor/hero.jpg',
      favicon32x32: '/websites/emcor/favicon-32x32.png',
      favicon16x16: '/websites/emcor/favicon-16x16.png',
      appleTouchIcon: '/websites/emcor/apple-touch-icon.png',
      siteWebmanifest: '/websites/emcor/site.webmanifest',
      browserconfig: '/websites/emcor/browserconfig.xml',
      heroVideoWebm: '/websites/emcor/hero.webm',
      aboutBg: '/websites/emcor/about_bg.webp',
      profilePdf: '/websites/emcor/profile.pdf',
      esgEnvironmental: 'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      esgSocial: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      esgGovernance: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      service1: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      service2: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      service3: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      service4: 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      service5: 'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      service6: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      news1: 'https://www.sumitomocorp.com/us/-/media/Images/us/scan/28-WIND-ENERGY.jpg?h=3456&iar=0&w=5184', // top-down desk with laptop and coffee
      news2: 'https://media.rff.org/images/Figure_1_TGimsXB.width-1480.png', // woman writing at desk
      news3: 'https://www.brown.edu/sites/default/files/styles/wide_sml/public/2023-04/Collage-final-final_0.jpg?h=96bb83be&itok=Jnu3VqIQ', // close-up newspaper
      news4: 'https://energyinnovation.org/wp-content/uploads/energy-innovation-default-opengraph-01.jpg', // hand writing with laptop
      news5: '/websites/emcor/Article5-bg.webp', // waste management / recycling
      team1: "/websites/emcor/technology-team-emcor.webp",
      team2: "/websites/emcor/equipment-team-emcor.webp",
      team3: "/websites/emcor/exploration-team-emcor.webp",
      team4: "/websites/emcor/investment-service-emcor.webp",
      team5: "/websites/emcor/refining-team-emcor.webp",
      team6: "/websites/emcor/innovation-team-emcor.webp",
      careersBg: '/websites/emcor/careers_hero.webp',
    },
    content: {
      localesPath: '/websites/emcor/locales',
    },
    seo: {
      titleKey: 'seo.title',
      descriptionKey: 'seo.description',
      keywordsKey: 'seo.keywords',
      ogImage: '/websites/emcor/og-image.jpg',
      ogImageWidth: '1200',
      ogImageHeight: '630',
      twitterSite: '@emcorgroup',
      canonicalDomain: 'emcorgroup.com',
    },
  },
  basrasky: {
    name: 'Basrasky',
    theme: {
      primaryColor: '#064e3b', // Dark green
      secondaryColor: '#059669', // Medium green
      fontFamily: {
        primary: 'Poppins',
        secondary: 'Poppins',
      },
    },
    assets: {
      logo: '/websites/basrasky/logo.png',
      heroBackground: '/websites/basrasky/hero.jpg',
      favicon: '/websites/basrasky/favicon.png',
      favicon32x32: '/websites/basrasky/favicon.png',
      favicon16x16: '/websites/basrasky/favicon.png',
      appleTouchIcon: '/websites/basrasky/favicon.png',
      siteWebmanifest: '/websites/basrasky/site.webmanifest',
      browserconfig: '/websites/basrasky/browserconfig.xml',
      heroVideoWebm: '/websites/basrasky/hero.webm',
      aboutBg: '/websites/basrasky/about.webp',
      profilePdf: '/websites/basrasky/profile.pdf',

      // ESG
      esgEnvironmental: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // forest
      esgSocial: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // team collaboration
      esgGovernance: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // meeting

      // Services
      service1: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // energy infrastructure
      service2: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // industrial facility
      service3: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // technology
      service4: 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // renewable energy
      service5: 'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // sustainability
      service6: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // business

      // News
      news1: 'https://images.unsplash.com/photo-1509395176047-4a66953fd231?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // newsroom
      news2: 'https://images.unsplash.com/photo-1634078111133-a1e12d6131b6?fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=60&w=3000', // writing
      news3: 'https://images.unsplash.com/photo-1515378791036-0648a3ff77b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // reading
      news4: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // workspace
      news5: '/websites/basrasky/Article5-bg.webp', // sustainability article
      team1: "/websites/basrasky/technology.jpg",
      team2: "/websites/basrasky/operations.jpg",
      team3: "/websites/basrasky/people.jpg",
      team4: "/websites/basrasky/finance.jpg",
      team5: "/websites/basrasky/engineering.jpg",
      team6: "/websites/basrasky/commercial.jpg",
      careersBg: '/websites/basrasky/careers_hero.webp',
    },

    content: {
      localesPath: '/websites/basrasky/locales',
    },
    seo: {
      titleKey: 'seo.title',
      descriptionKey: 'seo.description',
      keywordsKey: 'seo.keywords',
      ogImage: '/websites/basrasky/og-image.jpg',
      ogImageWidth: '1200',
      ogImageHeight: '630',
      twitterSite: '@basrasky',
      canonicalDomain: 'basrasky.com',
    },
  },
  citex: {
    name: 'CITEX',
    theme: {
      primaryColor: '#C62618', // Dark green
      secondaryColor: '#E82B2B', // Medium green
      fontFamily: {
        primary: 'Poppins',
        secondary: 'Poppins',
      },
    },
    assets: {
      logo: '/websites/citex/logo.png',
      heroBackground: '/websites/citex/citex-hero-banner.jpg',
      favicon: '/websites/citex/logo.png',
      favicon32x32: '/websites/citex/logo.png',
      favicon16x16: '/websites/citex/logo.png',
      appleTouchIcon: '/websites/citex/logo.png',
      siteWebmanifest: '/websites/citex/site.webmanifest',
      browserconfig: '/websites/citex/browserconfig.xml',
      heroVideoWebm: '/websites/citex/hero.webm',
      aboutBg: '/websites/citex/about.jpg',
      profilePdf: '/websites/citex/profile.pdf',

      // ESG
      esgEnvironmental: '/websites/citex/er-citex.jpeg', // forest
      esgSocial: '/websites/citex/si-citex.jpeg', // team collaboration
      esgGovernance: '/websites/citex/ge-citex.jpeg',

      // Services
      service1: 'https://s3.eu-west-2.amazonaws.com/assets.global-ec.com/Nexos0226_websize.jpg', // oil drilling rig
      service2: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // oil refinery complex
      service3: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // offshore oil platform
      service4: 'https://img.offshore-mag.com/files/base/ebm/os/image/2025/02/67b65d2f45d4991a70c9544c-dnv_subsea_operation.png?auto=format,compress&fit=fill&fill=blur&w=1200&h=630', // gas processing facility
      service5: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // oil storage tanks
      service6: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // pipeline infrastructure

      // News
      news1: 'https://images.unsplash.com/photo-1509395176047-4a66953fd231?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // newsroom
      news2: 'https://images.unsplash.com/photo-1634078111133-a1e12d6131b6?fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=60&w=3000', // writing
      news3: 'https://images.unsplash.com/photo-1515378791036-0648a3ff77b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // reading
      news4: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80', // workspace
      news5: '/websites/basrasky/Article5-bg.webp', // sustainability article
      team1: "/websites/basrasky/technology.jpg",
      team2: "/websites/basrasky/operations.jpg",
      team3: "/websites/basrasky/people.jpg",
      team4: "/websites/basrasky/finance.jpg",
      team5: "/websites/basrasky/engineering.jpg",
      team6: "/websites/basrasky/commercial.jpg",
      careersBg: '/websites/basrasky/careers_hero.webp',
    },

    content: {
      localesPath: '/websites/basrasky/locales',
    },
    seo: {
      titleKey: 'seo.title',
      descriptionKey: 'seo.description',
      keywordsKey: 'seo.keywords',
      ogImage: '/websites/basrasky/og-image.jpg',
      ogImageWidth: '1200',
      ogImageHeight: '630',
      twitterSite: '@basrasky',
      canonicalDomain: 'basrasky.com',
    },
  },
};

export function getWebsiteConfig(websiteName: string): WebsiteConfig {
  const config = websites[websiteName];
  if (!config) {
    throw new Error(`Website configuration not found for: ${websiteName}`);
  }
  return config;
}

export function getCurrentWebsite(): string {
  try {
    // Check if we're on the server side
    if (typeof process !== 'undefined' && process.env && process.env.WEBSITE) {
      return process.env.WEBSITE;
    }

    // Client side - try to get from window or default to bluesky
    if (typeof window !== 'undefined' && (window as any).__WEBSITE__) {
      return (window as any).__WEBSITE__;
    }

    // Default fallback
    return 'bluesky';
  } catch (error) {
    console.warn('Error getting current website, defaulting to bluesky:', error);
    return 'bluesky';
  }
}

export function getCurrentWebsiteConfig(): WebsiteConfig {
  const websiteName = getCurrentWebsite();
  return getWebsiteConfig(websiteName);
}
